import React from 'react';
import { withRouter } from 'react-router-dom';
import { StringHelpers, SystemText } from 'e4shared';
import posthog from 'posthog-js';
import { translateCourse } from 'helpers/translations';
import { useSelector } from 'react-redux';

export const LMS = ({ data }) => {
    const { user } = useSelector(state => state.user);

    const [course, setCourse] = React.useState({ extras1: '', extras2: '' });

    React.useEffect(() => {
        const temp = { ...data } || {};
        setCourse(translateCourse(user.language_Code, temp));
    }, [data]);

    const st = (s, x) => SystemText(`Search/Results/Training/${s}`, x);
    const accelerate = course.extras2 === 'accelerate';
    const challenger = course.extras2 === 'challenger';
    const learn2 = course.extras2 === 'learn2';
    const onClick = () => {
        if (accelerate || learn2) {
            posthog.capture('launched-learning', {
                course: course.name,
                course_status: course.extras4,
                course_id: course.id,
            });

            window.location.href = course.extras1;
        } else if (challenger) {
            posthog.capture('launched-challenger-learning', { course: course.name });
            window.open(course.extras1.replace('courseGroup', 'course'));
        } else {
            window.open(course.extras1);
        }
    };

    const labelClass = x => {
        switch (x.toLowerCase()) {
            case 'completed':
            case 'course_completed':
                return 'success';
            case 'in_progress':
            case 'course_started':
                return 'warning';
            default:
                return 'grey';
        }
    };

    // For challenger statuses
    if (course.extras4 === 'course_completed') course.extras4 = 'completed';
    if (course.extras4 === 'course_started') course.extras4 = 'in_progress';
    if (course.extras4 === 'license_access') course.extras4 = 'not_started';

    return (
        <div data-testid="lms-search" className="search-result box" onClick={onClick}>
            <div className="image-holder hidden-xs">
                <img src={`/dist/img/${course.extras2.toLowerCase()}-icon.png`} alt={course.extras2} loading="lazy" />
            </div>
            <div>
                <label className="label label-primary">
                    <i className="mr10 fa fa-comments" />
                    {st('Title')}
                </label>
                <h2>{course.name}</h2>
                {(course.description || course.summary) && <p>{course.description || course.summary}</p>}
                {course.extras5 && (
                    <div className="text-sm mt5" title={st('Duration')}>
                        <i className="fa fa-clock mr5" />
                        {course.extras5}
                    </div>
                )}
                {course.extras6 > 0 && (
                    <div className="text-sm mt5" title={st('Duration')}>
                        <i className="fa fa-clock mr5" />
                        {StringHelpers.displayMinutes(course.extras6 / 60)}
                    </div>
                )}
                {course.extras4 && (
                    <div className="text-sm mt5">
                        <label className={`label uppercase label-${labelClass(course.extras4)}`}>
                            {SystemText(`Search/Results/Training/Status/${course.extras4}`)}
                        </label>
                    </div>
                )}
                {/* {data.extras3 && (
                    <div>
                        {data.extras3.split('|').map(tag => (
                            <label
                                key={`tag-${data.id}-${tag.replace(' ', '')}`}
                                className="label label-default mr5 mt5"
                                style={{ display: 'inline-block' }}
                            >
                                {tag}
                            </label>
                        ))}
                    </div>
                )} */}
            </div>
        </div>
    );
};

export default withRouter(LMS);
